import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { Action, WorkerPool } from "types/generated";
import { checkAllowedAction } from "utils/access";

type WorkerPoolResetActionProps = {
  onAction: () => void;
  workerPool: WorkerPool;
};

const WorkerPoolResetAction = ({ onAction, workerPool }: WorkerPoolResetActionProps) => {
  const managedByK8sController = workerPool.managedByK8sController;
  const canResetWorkerPool = checkAllowedAction(workerPool, Action.WorkerPoolReset);
  const hasBusyWorkers = workerPool.busyWorkers > 0;

  const getTooltip = () => {
    if (managedByK8sController) {
      return "The credentials cannot be reset because this pool is managed via the Kubernetes controller.";
    }
    if (!canResetWorkerPool.result) {
      return canResetWorkerPool.message;
    }
    if (hasBusyWorkers) {
      return (
        <>
          Some workers are currently busy running jobs. Wait for the jobs to finish before
          proceeding.
          <br />
          <br />
          Resetting this worker pool means that existing workers can no longer be used and will need
          to be restarted with the new configuration.
        </>
      );
    }
    return (
      <>
        Resetting this worker pool means that existing workers can no longer be used and will need
        to be restarted with the new configuration.
      </>
    );
  };

  const isDisabled = !canResetWorkerPool.result || hasBusyWorkers || managedByK8sController;
  const tooltip = getTooltip();

  return (
    <DropdownMenuItem
      tooltipWidthMode="maxWidthSm"
      tooltipPlacement="left"
      tooltip={tooltip}
      onAction={onAction}
      isDisabled={isDisabled}
    >
      Reset
    </DropdownMenuItem>
  );
};

export default WorkerPoolResetAction;
